<!-- 全局多选 -->
<template>
  <div class="countDownWrap" v-if="store.state.user.userInfo.login && store.state.user.userInfo.creditRating == 0">
	  <img src="../../assets/img/icons/icon-em.png" class="em" alt="" @click="accountUnlockShow = true" style="cursor: pointer;"/>
	  <div class="txt">{{ $t("你的预约会议权限开放日为：") }} <span>{{ forDay(store.state.user.userInfo.limitTime) }}</span> </div>
  </div>

  <AccountUnlock  :isToastShow="accountUnlockShow" @closeToast="closeToast" ></AccountUnlock>
</template>

<script setup>

import {useStore} from "vuex";
import AccountUnlock from "../../components/accountUnlock/accountUnlock.vue";
import {ref} from "vue";

const store = useStore();
const accountUnlockShow = ref(false) // 账户解锁弹窗

// 关闭账户解锁弹窗
function closeToast(){
  accountUnlockShow.value = false
}

/**
 * 计算天数
 */
function intervalDay(time){
  if(time == null){
    return 0;
  }
  return Math.ceil( (time - new Date().getTime()) / 86400000 )
}

function forDay(time){
  let year = new Date(time).getFullYear()
  let month = new Date(time).getMonth() + 1
  let date = new Date(time).getDate() + 1
  return year + "/" + month + "/" + date

}

</script>

<style scoped>
	.countDownWrap{
		display: none;
	}
	@media screen and (max-width: 750px) {
		.countDownWrap{
			width: 100%;
			height: 8.53333vw;
			display: flex;
			flex-direction: row;
			align-items: center;
			background-color: #EAEAEF;
			justify-content: center;
			font-size: 3.2vw;
			color: #171A41;
		}

		.countDownWrap .em{
			width: 4.26666vw;
			height: 4.26666vw;
			margin-right: 0.93333vw;
		}

		.countDownWrap .txt span{
			font-size: 4.26666vw;
			color: #B41D23;
		}
	}

</style>
